import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import { getMomaTracesStyleHover } from "../style/momaTraces";

export function getMomaTracesInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: getMomaTracesStyleHover,
  });
  clickSelect.on("select", function (e) {
    const sessions = [
      ...new Set(
        e.target
          .getFeatures()
          .getArray()
          .map((f) => f.get("session")),
      ),
    ];
    control.set("selectedSessions", sessions);
  });
  return [
    clickSelect,
    new Select({
      layers: [layer],
      condition: pointerMove,
      style: getMomaTracesStyleHover,
    }),
  ];
}
